module.exports = __webpack_public_path__ + "static/img/img_10.3956920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events_gallery/img_10.jpg
// module id = N6KV
// module chunks = 0